import script from "./McpApiKeyExpiryDialog.vue?vue&type=script&setup=true&lang=js"
export * from "./McpApiKeyExpiryDialog.vue?vue&type=script&setup=true&lang=js"

import "./McpApiKeyExpiryDialog.vue?vue&type=style&index=0&id=2be68a70&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2be68a70"]])

export default __exports__